<template>
    <v-card
        elevation="0"
        outlined
        class="pa-4"
        style="border-radius: 16px;"
    >   
        <v-row class="ma-0 d-flex justify-start">
            <p class="txt ma-0" style="font-size: 16px;font-weight: 600;">{{ title }}</p> 
        </v-row>
        <div  class="chart-container" >
            <v-chart ref="chart" :options="chartOptions" autoresize style="width:100%; height:100%" />
        </div>
        <v-row class="ma-0">
            <div class="d-flex align-center" v-if="itemsEnPares.length > 0" style="width: 100%;">
                <v-btn
                    icon
                    small
                    v-if="itemsEnPares.length > 1"
                    @click="prevSlide"
                >
                    <v-icon>mdi-chevron-left</v-icon>
                </v-btn>

                <v-window v-model="currentSlide" class="flex-grow-1">
                    <v-window-item v-for="(par, index) in itemsEnPares" :key="index">
                        <v-row class="d-flex ma-0">
                            <div
                                v-for="item in par"
                                :key="item.label"
                                class="d-flex justify-space-between"
                                style="width: 100%;"
                            >
                                <p class="txt">{{ item.label }}</p>
                                <p class="subtxt">{{ item.total }}</p>
                            </div>
                        </v-row>
                    </v-window-item>
                </v-window>

                <v-btn
                    icon
                    small
                    v-if="itemsEnPares.length > 1"
                    @click="nextSlide"
                >
                    <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
            </div>
        </v-row>
    </v-card>
</template>

<script>
    import ECharts from 'vue-echarts';
    import 'echarts/lib/chart/pie';
    import 'echarts/lib/component/tooltip';
    import 'echarts/lib/component/title';
import PerfectScrollbar from 'perfect-scrollbar';
    export default {
        components: {
            'v-chart': ECharts
        },
        props:{
            title:{
                required:true,
                default: "Titulo"
            },
            centerText:{
                required:false,
                default: "Total"
            },
            items:{
                required: true,
                default: []
            },
            colorItem:{
                required: false,
                default: () => '#1E2245'
            },
            colorBackground:{
                required: false,
                default: '#c4c4c4'
            },
            noColorRepeat:{
                required: false,
                default: false
            }
        },
        data(){
            return{
                data:[],
                chartOptions: null,
                total: 0,
                tituloModal: '',
                tituloTotal:'',
                text: '',
                dialog: false,
                hasData: false,
                currentSlide: 0,
                shuffledColors: [],
                colorIndex: 0

            }
        },
        computed:{
            itemsEnPares(){
                let size = 2
                let result = []
                for(let i = 0; i < this.items.length; i += size){
                    result.push(this.items.slice(i, i + size))
                }
                // Si el último grupo tiene solo un elemento, agregar uno vacío
                if(result.length > 0 && result[result.length - 1].length === 1){
                    result[result.length - 1].push({label: '', total: ''})
                }
                return result
            }
        },
        watch:{
            itemsEnPares(){
                this.currentSlide = 0
            }
        },
        methods: {
            shuffleArray(array) {
                const newArray = [...array];
                for (let i = newArray.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
                }
                return newArray;
            },
            getRandomColor(){
                if(Array.isArray(this.colorItem)){
                    if(this.noColorRepeat){
                        const color = this.shuffledColors[this.colorIndex % this.shuffledColors.length];
                        this.colorIndex++;
                        return color;
                    }
                    return this.colorItem[Math.floor(Math.random() * this.colorItem.length)]
                }
                return this.colorItem
            },
            logData(){
                //console.log(this.items)
                this.colorIndex = 0;
                if(this.noColorRepeat && Array.isArray(this.colorItem)){
                    this.shuffledColors = this.shuffleArray(this.colorItem);
                } else if(Array.isArray(this.colorItem)){
                    this.shuffledColors = this.colorItem;
                }
                
                if(this.items.length == 0 ||  this.items[0].cantidad == 0){
                    this.data.push({name: 'Total', value: 0})
                    this.hasData = false
                    this.total = 0
                    this.text = this.centerText
                }
                else{
                    this.hasData = true
                    
                    this.data = this.items.map((el) => ({name: el.label, value: el.total}))
                    this.items.forEach((el) => {
                        this.total = this.total + el.total
                    })
                    this.text = this.centerText
                
                }
                this.setChartOptions()
            },

            prevSlide(){
                this.currentSlide = this.currentSlide > 0
                    ? this.currentSlide - 1
                    : this.itemsEnPares.length - 1
            },
            nextSlide(){
                this.currentSlide = this.currentSlide < this.itemsEnPares.length - 1
                    ? this.currentSlide + 1
                    : 0
            },
            
            setChartOptions() {
            const pieData = this.data.map(item => ({
                ...item,
                itemStyle: {
                color: this.hasData ?  this.getRandomColor() : this.colorBackground,
                borderColor: '#fff',
                borderWidth: 3
                }
            }));

            const tooltipConfig = this.hasData ? {
                trigger: 'item',
                formatter: '{b}: {c} ({d}%)',
                confine: true,
                textStyle: {
                    fontSize: 12
                }
            } : {
                show: false
            };

            this.chartOptions = {
                title: {
                text: this.total,
                subtext: this.text,
                left: 'center',
                top: '42%',
                textStyle: {
                    fontSize: 24,
                    fontWeight: 'normal',
                },
                subtextStyle:{
                    fontSize: 20
                }
                },
                tooltip: tooltipConfig,
                series: [
                {
                    name: 'Data',
                    type: 'pie',
                    radius: ['50%', '70%'],
                    label: {
                        show: false
                    },
                    
                    labelLine: {
                    show: false
                    },
                    data: pieData,
                    emphasis: {
                        disabled: !this.hasData,
                        itemStyle: this.hasData ? {} : {opacity: 1}
                    }
                }
                ]
            };
            },
            addMouseEvents() {
                this.$nextTick(() => {
                    if (!this.hasData) return;
                    
                    const chart = this.$refs.chart.chart;
                    chart.on('mouseover', (params) => {
                    if (params.componentType === 'series') {
                        // console.log(params)
                        chart.setOption({
                        title: {
                            text: `${params.data.value}`,
                            subtext: `${this.text}`
                        }
                        });
                    }
                    });

                    chart.on('mouseout', () => {
                    chart.setOption({
                        title: {
                        text: this.total,
                        subtext: this.text
                        }
                    });
                    });
                });
            },
            /* abrirModal(){
                

                this.dialog = true
            }  */          
        },
        created() {
            this.logData();
        },
        mounted(){
            this.addMouseEvents();
            this.$nextTick(() => {
                setTimeout(() => {
                    if(this.$refs.chart){
                        this.$refs.chart.resize();
                    }
                }, 100);
            })
        }
    }
</script>

<style scoped >
.txt{
    margin-bottom: 5px;
    font-size: 14px;
    color: #6b7590;
    font-weight: 500;
    font-family: 'Montserrat';
    min-height: 20px;
}
.subtxt{
    margin-bottom: 5px;
    font-size: 14px;
    color: #1A2233;
    font-weight: 500;
    min-height: 20px;
}

.chart-container{
    width: 100%;
    max-width: 300px;
    aspect-ratio: 1 / 1;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    overflow: hidden;
}

</style>